import React, { useState } from 'react';
import { useParams, Link } from 'react-router';
import { motion, AnimatePresence } from 'framer-motion';
import AnimacionPagina from '../componentes/AnimacionPagina';
import styled from 'styled-components';
import Header from '../componentes/Header';
import WhatsAppShareButton from '../componentes/WhatsAppShareButton';
import BtnVolverAnim from '../elementos/BtnVolverAnim';
import informacionToldos from '../data/todosLosProductos/informacionToldos';
import ModalImagenExpandida from '../componentes/ModalImagenExpandida';
import { Helmet } from 'react-helmet';
import Footer from '../componentes/Footer';

const DetallesToldos = () => {
  const { slug } = useParams();
  const producto = informacionToldos.find(
    p => p.slug === slug
  );
  
      const [imagenExpandida, setImagenExpandida] = useState(null);

  if (!producto) return <h2>Producto no encontrado</h2>;



  return (
    <>
    <Helmet>
      <title>Toldos para Exteriores | Hi Blinds</title>
      <meta name="description" content="Toldos funcionales para exteriores. Protección solar y diseño elegante para terrazas, patios y más." />
      <meta property="og:title" content="Toldos para Exteriores | Hi Blinds" />
      <meta property="og:description" content="Protege tus espacios al aire libre con estilo y calidad. Toldos retráctiles, palillería y más." />
      <meta property="og:url" content="https://hiblinds.com/toldos" />
    </Helmet>
    <Header />
    <AnimacionPagina>
      <FichaToldos>
        <ImgToldoContainer
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.7 }}
            onClick={(e) => {
            e.stopPropagation();
            setImagenExpandida(producto.images[0])}}
        >
            <img src={producto.images[0]}
            alt={producto.nombre}
            
            />
        </ImgToldoContainer>
        <h1>{producto.nombre}</h1>
        <h3>{producto.categoria}</h3>
        <b>beneficios:</b>
            {producto.beneficios.map((categoria) => (
                <p>• {categoria}<br/></p>   
            ))}
        <br/>
        <b>Instalación:</b>
        {producto.instalacion.map((instalacion) => (
                <p>• {instalacion}<br/></p>   
            ))}
        <br/>
        <h3>Textil para la cubierta:</h3>
        <p>{producto.cubierta}</p>

        <br/>
        <h3>Medidas máximas:</h3>
        <p>{producto.anchoMaximo}</p>
        <p>{producto.alturaMaxima}</p>
        <br/>

        <h3>Garantía Solair®</h3>
        <p>{producto.garantia}</p>


            

          <BtnVolverAnim Ref='/toldos'/>
          <WhatsAppShareButton message="Te comparto este modelo de Toldo" />
      </FichaToldos>
      <Footer />
    </AnimacionPagina>
    <ModalImagenExpandida
        imagen={imagenExpandida}
        onClose={() => setImagenExpandida(null)}
    />
    </>
    
  );
};
const FichaToldos = styled.div `
  padding: 30px;
  max-width: 900px;
  margin: 0 auto;
  margin-top: 30px;

  h1 {
    text-align: center;
  }
  
  
  a {
    background-color:  #002A48;
    color: #fff;
    padding: 10px 30px;
    text-decoration: none;
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  h2 {
    text-align: center;
    margin-bottom: 15px;
  }
`
const ImgToldoContainer = styled(motion.div) `
    max-width: 500px;
    margin: auto;
    

    img {
        height: 100%;
        width: 100%;
    border-radius: 10px;
    }
`
    

    

export default DetallesToldos;